import React from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";

export function Brand({ className = "", dark = false }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2 font-heading font-extrabold text-xl tracking-tight ${dark ? "text-white" : "text-midnight"} ${className}`} data-testid="brand-logo">
      <span className={`relative grid place-items-center w-8 h-8 rounded-lg ${dark ? "bg-white text-midnight" : "bg-midnight text-white"}`}>
        <Layers size={18} strokeWidth={2.4} />
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-lime border-2 border-white" />
      </span>
      PaySignal
    </Link>
  );
}

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
        <div className="w-full max-w-sm mx-auto lg:mx-0">
          <Brand className="mb-10" />
          <h1 className="font-serif font-normal text-3xl sm:text-4xl tracking-tight text-espresso">{title}</h1>
          {subtitle && <p className="mt-2 text-espresso-soft">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-espresso-soft">{footer}</div>}
        </div>
      </div>
      <div className="hidden lg:flex flex-col justify-between bg-espresso text-cream p-14 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-olive/25 blur-3xl pointer-events-none" />
        <div className="absolute bottom-24 -left-10 w-48 h-48 rounded-full bg-lime/15 blur-3xl pointer-events-none" />
        <Brand dark />
        <div className="relative z-10">
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-lime mb-5">The freelancer's ledger</p>
          <h2 className="font-serif font-light text-4xl leading-[1.12] tracking-tight text-cream">
            Know exactly what money is coming — and what hasn't <em className="italic text-lime">arrived.</em>
          </h2>
          <p className="mt-5 text-cream/70 leading-relaxed max-w-md">
            Track invoices and expected platform payouts from one calm ledger. Optional, quiet
            account alerts when important dates or payment states change.
          </p>
        </div>
        <div className="relative z-10 space-y-3">
          {["INV-3814 · North Coast Studio", "PAY-1402 · Freelance Platform", "INV-3815 · Brightline Creative"].map((r, i) => (
            <div key={i} className="flex items-center justify-between border border-cream/15 rounded-xl px-4 py-3 bg-cream/5 backdrop-blur-sm">
              <span className="text-sm text-cream/80">{r}</span>
              <span className="font-num text-sm text-cream">$1,2{i}0.00</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
